import { TODO } from '@habity/types';
import { createClient } from './client';

// export type TableType = 'agencies' | 'searches';

export const getTableColums = (table: string) => {
  switch (table) {
    case 'agencies':
      return '*, statuses(*)';
    default:
      return '*';
  }
};

export const getAll = async (
  table: string,
  agencyId: string | null
): Promise<TODO[]> => {
  const supabaseClient = createClient();
  // SUPABASE: Call backend fn instead of sb directly
  const query = supabaseClient
    .from(table)
    .select(getTableColums(table))
    .eq('agency', Number(agencyId));
  const { data, error } = await query.returns<TODO[]>();
  if (error) {
    throw error;
  }
  return data;
};

export const get = async (
  table: string,
  id?: string | null
): Promise<TODO | null> => {
  if (!id) {
    return null;
  }
  const supabaseClient = createClient();
  // SUPABASE: Call backend fn instead of sb directly
  const query = supabaseClient
    .from(table)
    .select(getTableColums(table))
    .eq('id', Number(id));
  const { data, error } = await query.returns<TODO[]>().maybeSingle();
  if (error) {
    throw error;
  }
  return data;
};
